import React from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';

import StarsButton from '@swf/components/StarsButton/StarsButton';
import { RoutingKey } from '@swf/core/enums';
import { select } from '@swf/core/store';
import { ClubRoute } from '@swf/core/types/Poker';
import { generatePath } from '@swf/core/utils/paths';

import { TXTWCL_All_Results } from './BackButton.messages.json';
import styles from './ResultsHeader.scss';
import ArrowLeftIcon from './assets/arrow-left.svg';

const BackButton: React.FC = () => {
  const { clubId } = useParams<{ clubId: string }>();
  const { routes } = useSelector(select.page.getMeta);

  return (
    <div className={styles.backContainer}>
      <StarsButton
        className={styles.back}
        variant="text"
        icon={<ArrowLeftIcon />}
        translation={TXTWCL_All_Results}
        href={generatePath(routes?.[RoutingKey.HomeGamesClubs] ?? '', {
          clubId,
          section: ClubRoute.Results
        })}
      />
    </div>
  );
};

export default BackButton;
